import { Button } from "antd-mobile";
import { SearchOutline } from "antd-mobile-icons";
import styles from "./index.module.scss";
import React, { useState } from "react";

interface SearchBarWithButtonProps {
  value: string;
  onChange: (value: string) => void;
  onConfirm?: () => void;
  placeholder?: string;
  showButton?: boolean;
  buttonText?: string;
}

const SearchBarWithButton: React.FC<SearchBarWithButtonProps> = ({
  value,
  onChange,
  onConfirm,
  placeholder = "搜索",
  showButton = true,
  buttonText = "确认",
}) => {
  const [showClearIcon, setShowClearIcon] = useState(false);
  const inputRef = React.useRef<HTMLInputElement>(null);
  const blurTimeoutRef = React.useRef<NodeJS.Timeout | null>(null);

  const onFocus = () => {
    // 清除可能存在的 blur 延迟
    if (blurTimeoutRef.current) {
      clearTimeout(blurTimeoutRef.current);
      blurTimeoutRef.current = null;
    }
    setShowClearIcon(value.length > 0);
  };

  const onBlur = () => {
    // 延迟隐藏清空按钮，给点击事件时间触发
    blurTimeoutRef.current = setTimeout(() => {
      setShowClearIcon(false);
    }, 200);
  };

  const handleClear = () => {
    onChange("");
    // 保持输入框焦点
    inputRef.current?.focus();
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const currentValue = event.target.value;
    onChange(currentValue);
    if (currentValue.length > 0 && !showClearIcon) {
      setShowClearIcon(true);
    }
  };

  return (
    <div className={styles.searchBar}>
      <div className={styles.keywordInput}>
        <SearchOutline className={styles.searchIcon} />
        <input
          ref={inputRef}
          className={styles.inputText}
          placeholder={placeholder}
          type="text"
          value={value}
          onChange={handleInputChange}
          onFocus={onFocus}
          onBlur={onBlur}
        />
        <div
          className={`${styles.clearIcon} ${showClearIcon ? styles.active : ""}`}
          onClick={handleClear}
        />
      </div>
      {showButton && (
        <Button className={styles.confirmButton} onClick={onConfirm}>
          {buttonText}
        </Button>
      )}
    </div>
  );
};

export default SearchBarWithButton;
